
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/uiuxdesign-lp2",
      function () {
        return require("private-next-pages/services/uiuxdesign-lp2.tsx");
      }
    ]);
  